import { render, staticRenderFns } from "./NawiMechCustomData.vue?vue&type=template&id=8fda96f2&"
import script from "./NawiMechCustomData.vue?vue&type=script&lang=js&"
export * from "./NawiMechCustomData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports